import React from "react"
import { b2cPolicies } from "./AuthConfig"
import Loader from "../Components/Shared/Loader/loader"
import { Navigate, useParams } from 'react-router-dom'
import { useMsal } from "@azure/msal-react"

const SignUp = () => {
    const context = useMsal()
    const { signupIdentity } = useParams()
    // get url params tag from url
    const urlParams = new URLSearchParams(window.location.search);
    let tag = urlParams.get('tag');
    let email = urlParams.get('email');
    let isFromCopilot = urlParams.get('isFromCopilot');
    // get urlparams selectedOrganization from url
    let selectedOrganization = urlParams.get('selectedOrganization');

    // store tags if defined in local storage else remove item from local storage

    if (selectedOrganization) {
        localStorage.setItem("selectedOrganizationId", selectedOrganization);
    } else {
        localStorage.removeItem("selectedOrganizationId");
    }

    if (tag) {
        tag = tag.replace(/ /g, ', ');
        localStorage.setItem("domainTagSelection", tag);
    } else {
        localStorage.removeItem("domainTagSelection");
    }

    if (context.inProgress !== "none") {
        return <Loader />
    }

    const loginRequest = {
        ...b2cPolicies.authorities.signUpSignIn,
        extraQueryParameters: {
            signup: true,
            email: email || "",
            isFromCopilot: isFromCopilot
        }
    }

    if (signupIdentity) {
        loginRequest.extraQueryParameters.signupIdentity = signupIdentity;
    }

    if (context.accounts.length === 0) {
        context.instance.loginRedirect(loginRequest)
        return <div></div>
    } else {
        return (
            <Navigate to="/" />
        )
    }
}

export default SignUp
